import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertCategoryCard = ({ title, icon, count, metric, trend, critical, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    destructive: 'bg-destructive/10 text-destructive border-destructive/20'
  };

  const getTrendColor = () => {
    if (trend > 0) return 'text-success';
    if (trend < 0) return 'text-destructive';
    return 'text-muted-foreground';
  };

  return (
    <div className={`relative bg-card border rounded-xl p-6 hover:shadow-lg transition-shadow ${
      critical > 0 ? 'border-destructive shadow-destructive/20' : 'border-border'
    }`}>
      {critical > 0 && (
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-destructive text-white text-xs font-semibold rounded-full">
          <Icon name="AlertCircle" size={12} strokeWidth={2} />
          {critical}
        </div>
      )}

      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} strokeWidth={2} />
        </div>
        
        <div className="flex-1">
          <h3 className="text-sm font-medium text-muted-foreground mb-1">{title}</h3>
          <div className="flex items-baseline gap-2">
            <span className="text-3xl font-bold text-foreground">{count}</span>
            {trend !== 0 && (
              <span className={`text-sm font-medium flex items-center gap-1 ${getTrendColor()}`}>
                <Icon name={trend > 0 ? 'TrendingUp' : 'TrendingDown'} size={14} strokeWidth={2} />
                {Math.abs(trend)}%
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground mt-1">{metric}</p>
        </div>
      </div>
    </div>
  );
};

export default AlertCategoryCard;